const optimisticFolderNameReference: { current: { folderId: string; name: string } | undefined } = {
  current: undefined,
};

const setOptimisticFolder = (folderId: string, name: string) => {
  optimisticFolderNameReference.current = { folderId, name };
};

const getOptimisticFolder = (folderId?: string) =>
  folderId && optimisticFolderNameReference.current?.folderId === folderId
    ? optimisticFolderNameReference.current.name
    : undefined;

const clearOptimisticFolder = () => {
  optimisticFolderNameReference.current = undefined;
};

const getOptimisticFolderReference = () => {
  return optimisticFolderNameReference;
};

export const useOptimisticFolderName = () => {
  return { setOptimisticFolder, getOptimisticFolder, clearOptimisticFolder };
};

export { getOptimisticFolderReference };
